<template>
  <div>
    <AtomSpinnerCentred v-if="loading" />
    <Chart
      v-if="!loading"
      :date-range="dateRange"
      :width="graphWidth"
      :data-sets="dataSets"
    />
  </div>
</template>

<script>
import Chart from "@/components/general-components/chart/Chart";
import { getVictorianData } from "@/modules/dashboard/utilities/victorianStatisticsCalculator";
import AtomSpinnerCentred from "@/components/general-components/loading/AtomSpinnerCentred";
import { graphMixin } from "@/modules/dashboard/utilities/graphMixin";

export default {
  mixins: [graphMixin],

  name: "VictorianStatisticsCard",
  components: { Chart, AtomSpinnerCentred },
  data() {
    return {
      dateRange: [],
      dataSets: [],
      loading: true
    };
  },
  mounted() {
    getVictorianData()
      .then(response => {
        this.dateRange = response.dateRange;
        this.dataSets.push(response.dataSets.activeCaseData);

        this.loading = false;
      })
      .catch(error => {
        console.error(error);
      });
  }
};
</script>

<style scoped></style>
